/* eslint-disable jsx-a11y/label-has-associated-control */
// TODO: Fix accessibility

import { FC, useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FILTER_NAMES } from '../../../../components/filters/hooks/filter-names.constants';
import { useAppAsyncFilterOptions } from '../../../../hooks/filters/use-app-filter-options.hook';
import { IMAGES_REPO } from '../../../../static-resources/home-image-repo';
import { SCENARIO_PLANNER_METRICS } from '../scenario-planner.constants';

interface MassEditPropertyBlockProps {
  index: number;
  selectedField: string;
  changeType: string;
  changeValue: string;
  onFieldChange: (index: number, value: string) => void;
  onChangeTypeChange: (index: number, value: string) => void;
  onValueChange: (index: number, value: string) => void;
  onReset: (index: number) => void;
  disabledFields?: string[];
}
const DOD_APUP = [
  SCENARIO_PLANNER_METRICS.DEPTH_OF_DISCOUNT,
  SCENARIO_PLANNER_METRICS.ANY_PROMO_UNIT_PRICE,
];
const MassEditPropertyBlock: FC<MassEditPropertyBlockProps> = ({
  index,
  selectedField,
  changeType,
  changeValue,
  onFieldChange,
  onChangeTypeChange,
  onValueChange,
  onReset,
  disabledFields,
}) => {
  const { options: fieldOptions } = useAppAsyncFilterOptions(
    FILTER_NAMES.SCENARIOPLANNERFIELD,
    [],
    null,
  );
  const { options: inputTypeOptions } = useAppAsyncFilterOptions(
    FILTER_NAMES.SCENARIOPLANNERINPUTYPE,
    [],
    null,
  );
  const disabledOptions = useMemo(() => {
    return (
      disabledFields
        // Includes the field selected in this component.
        ?.filter((i) => i !== selectedField)
        .filter(
          (i) =>
            !(
              DOD_APUP.indexOf(i) !== -1 &&
              DOD_APUP.indexOf(selectedField) !== -1
            ),
        )
    );
  }, [disabledFields, selectedField]);
  return (
    <div className="mass-edit-block">
      <label className="section-label">Edit</label>
      <select
        className="form-control mb-2"
        value={selectedField}
        onChange={(e) => onFieldChange(index, e.target.value)}
      >
        {fieldOptions.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={disabledOptions?.indexOf(option.value) !== -1}
          >
            {option.label}
          </option>
        ))}
      </select>

      <label className="section-label">Change By</label>
      <div className="change-row">
        <select
          className="form-select change-type"
          value={changeType}
          onChange={(e) => onChangeTypeChange(index, e.target.value)}
        >
          {inputTypeOptions?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <input
          type="number"
          className="form-control change-input"
          value={`${changeValue}`}
          onChange={(e) => onValueChange(index, e.target.value)}
          placeholder="Enter value"
        />
        <Button
          className={` btn-run mass-edit-refresh-icon d-flex gap-2 justify-content-center align-items-center ${!changeValue ? 'disabled' : ''}`}
          onClick={() => {
            if (changeValue) {
              onReset(index);
            }
          }}
        >
          <img src={IMAGES_REPO.MassEditRefreshIcon} alt="mass-edit-icon" />
          Reset
        </Button>
      </div>
    </div>
  );
};

export default MassEditPropertyBlock;
